
import { defineComponent, ref, computed, watch } from 'vue';
import Modal from '@/components/general/molecules/Modal.vue'
import TextField from '@/components/general/atoms/TextField.vue';
import Alert from '@/components/general/atoms/Alert.vue';
import Selector from '@/components/general/atoms/Selector.vue';
import { CommunityService } from '@/services/communities/CommunityServices';
import { useRoute } from 'vue-router';
import { Users, Unit, unitBase } from '@/services/communities/types'
import { validateEmailStructure, validateRut, verifyPhoneNumberFormat } from '@/services/auth/AuthUtils'
import inputChipAuxVue from '@/components/general/atoms/inputChipAux.vue';
import SearchSelector from '@/components/general/atoms/SearchSelector.vue';
export default defineComponent({
    emit: ["update:visible", "update", "closeModal", "create"],
    props: {
        action: {
            type: String,
            required: true,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Users,
            required: false,
        }
    },
    setup(props, { emit }) {
        const establishments = [
            { value: 1, label: 'Oficina' },
            { value: 2, label: 'Residencia' },
            { value: 3, label: 'Local Comercial' },
        ];
        const route = useRoute();
        const communityId = ref<number>(typeof route.params.id === 'string' ? parseInt(route.params.id) : 0);
        const CommunityServices = new CommunityService();
        const showEmployeeRegister = ref<boolean>(false)
        const firsName = ref<string>(props.user?.user.firstName || '')
        const lastName = ref<string>(props.user?.user.lastName || '')
        const phone = ref<string>(props.user?.user.phone || '')
        const email = ref<string>(props.user?.user.email || '')
        const age = ref<number>(props.user?.user.age || 0)
        const rut = ref<string>(props.user?.user.dni || '')
        const establishmentType = ref<number>(0)
        const position = ref<string>(props.user?.position || '')
        const isCommiteMember = ref<boolean>(props.user?.isCommitteeMember || false)
        const commitePosition = ref<string>(props.user?.committeePosition || '')
        const hasReducedCapacity = ref<boolean>(props.user?.user.hasReducedCapacity || false)
        const reducedCapacityDetails = ref<string>(props.user?.user.reducedCapacityDetails || '')
        const parkingSpace = ref<string>('')
        const activeInput = ref<boolean>(true)
        const warehouseSpace = ref<string>('')
        const isFab = ref<boolean>(props.user?.isFab || false)
        const floor = ref<number>(0)
        const showModalEdit = ref<boolean>(false)
        const searchTableData = ref([firsName, lastName, phone, email, rut, parkingSpace, warehouseSpace]);
        const showButtons = computed(() => true)
        const numBlock = ref<string>('')
        const address = ref<string>('');
        const showAlertModal = ref<boolean>(false)
        const selectedUnit = ref<string>('0');
        const unitSelector = ref<number>(0);
        const profession = ref<string>(props.user?.user.profession || '')
        const message = ref<string>('');
        const loading = ref<boolean>(false);
        const hasPhoneError = ref<boolean>(false);
        const hasEmailError = ref<boolean>(false);
        const hasRutError = ref<boolean>(false);
        const showAlert = ref<boolean>(false);
        const wareHouses = ref<string[]>(props.user?.warehouses.map((item) => item.description) || []);
        const parkings = ref<string[]>(props.user?.parkingSpots.map((item) => item.description) || []);
        const units = ref<unitBase[]>(props.user?.communityUserUnits.map((item) => item.unit) || []);
        const unitsList = ref<Unit[]>([]);
        const blockList = ref([{}]);
        const blockId = ref<number>(props.user?.communityUserUnits[0].unit.blockId || 0);
        const showAlertMessage = ref<string>('')
        const alertType = ref<string>('')
        const currentUnitUpdate = ref()
        const unitType = ref<string>('new')
        const dropWareHouse = (itemIndex: number) => {
            wareHouses.value.splice(itemIndex, 1);
        };
        watch(showAlert, (newValue) => {
            if (newValue) {
                setTimeout(() => {
                    showAlert.value = false;
                }, 3000);
            }
        });

        const init = () => {
            CommunityServices.getBlocksCommunity(communityId.value)
                .then((response) => {
                    response.data.map((e: any) => {
                        const myObject = {
                            value: e.id,
                            label: e.name
                        };
                        blockList.value.push(myObject)
                    })
                })
                .catch((error) => {
                    console.error(error)
                })
        }

        init()
        const addWareHouse = () => {
            if (warehouseSpace.value) {
                wareHouses.value.push(warehouseSpace.value)
                warehouseSpace.value = ''
            }
            else {

                showAlertMessage.value = 'Verifique que no existan campos vacios';
                alertType.value = 'warning';
                showAlert.value = true;
            }
        };
        const addParking = () => {
            if (parkingSpace.value) {
                parkings.value.push(parkingSpace.value);
                parkingSpace.value = '';
            }
            else {

                showAlertMessage.value = 'Verifique que no existan campos vacios';
                alertType.value = 'warning';
                showAlert.value = true;
            }
        }
        const dropParking = (itemIndex: number) => {
            parkings.value.splice(itemIndex, 1);
        }
        const isFieldsFilled = computed(() => {
            return firsName.value && lastName.value && phone.value && email.value && units.value.length > 0
        });
        function onUpdateModelEstablishment(value: number) {
            establishmentType.value = value
        }
        function onUpdateBlockId(value: number) {
            blockId.value = value
        }
        const showModalAdd = ref<boolean>(props.visible)
        const closeModal = () => {

            showModalAdd.value = false
            emit('closeModal')
        }
        const addUnit = () => {
            if (establishmentType.value && floor.value && address.value && props.action === 'create') {
                units.value.push({
                    floor: floor.value,
                    address: address.value,
                    establishmentType: Number(establishmentType.value),
                    blockId: blockId.value
                })
                floor.value = 0
                address.value = ''
            }
            else if (props.action === 'update' || unitType.value === 'existing') {
                units.value.push(currentUnitUpdate.value)
            }
            else {
                showAlert.value = true;
                showAlertMessage.value = 'Verifique que no existan campos vacios';
                alertType.value = 'warning';
            }

        }
        const dropUnit = (itemIndex: number) => {
            units.value.splice(itemIndex, 1);
        }
        const saveUser = async () => {
            loading.value = true
            let unitsAux = units.value.reduce((acc: number[], item) => {
                if (item.id !== undefined) {
                    acc.push(item.id);
                }
                return acc;
            }, []);
            if (props.action === 'create') {
                const userCommunity = {
                    userInfo: {
                        firstName: firsName.value,
                        lastName: lastName.value,
                        profession: profession.value,
                        age: age.value,
                        phone: phone.value,
                        hasReducedCapacity: hasReducedCapacity.value,
                        reducedCapacityDetails: reducedCapacityDetails.value,
                        email: email.value,
                        dni: rut.value,
                    },
                    communityUserInfo: {
                        position: position.value,
                        userRole: 1,
                        isActive: true,
                        isCommitteeMember: isCommiteMember.value,
                        committeePosition: commitePosition.value,
                        isFab: isFab.value,
                        communityId: communityId.value,
                    },
                    unitsInfo: units.value.filter((item) => item.id === undefined),
                    warehouses: wareHouses.value,
                    parkingSpots: parkings.value,
                    unitsIds: unitsAux
                }
                await CommunityServices.createResidentInCommunity(communityId.value, userCommunity);
                loading.value = false
                emit('create')
            } else if (props.action === 'update' && props.user) {

                const userUpdate = {
                    userUpdate: {
                        firstName: firsName.value,
                        lastName: lastName.value,
                        profession: profession.value,
                        age: age.value,
                        phone: phone.value,
                        hasReducedCapacity: hasReducedCapacity.value,
                        reducedCapacityDetails: reducedCapacityDetails.value,
                        email: email.value,

                    },
                    communityUserEdit: {
                        userId: props.user?.userId,
                        communityId: communityId.value,
                        userRole: 1,
                        position: position.value,
                        parkingSpace: parkingSpace.value,
                        warehouseSpace: warehouseSpace.value,
                        isCommitteeMember: isCommiteMember.value,
                        committeePosition: commitePosition.value,
                        isFab: isFab.value,
                    },
                    warehouses: wareHouses.value,
                    parkingSpots: parkings.value,
                    communityUnits: unitsAux
                }
                await CommunityServices.updateUsersCommunity(communityId.value, props.user?.communityUserUnits[0]?.communityUserId, userUpdate);
                loading.value = false
                emit('create')
            }
        };
        function runValidations() {
            let valid = true;
            if (!validateRut(rut.value)) {
                valid = false
                hasRutError.value = true
            }
            else {
                hasRutError.value = false
            }
            if (!validateEmailStructure(email.value)) {
                valid = false
                hasEmailError.value = true
            }
            else {
                hasEmailError.value = false
            }
            return valid
        }
        const getUnits = async () => {

            await CommunityServices.getUnitsCommunity(communityId.value)
                .then((response) => {
                    unitsList.value = response.data

                })
                .catch((error) => {
                    console.error(error)
                })
        }
        getUnits()
        const formattedUnitList = computed(() => {
            return unitsList.value
                .filter(item => !units.value.some(unit => unit.id === item.id))
                .map(item => {
                    return {
                        id: item.id,
                        name: item.address
                    }
                })
        })


        const onSelect = (item: Record<string, any>) => {
            currentUnitUpdate.value = unitsList.value.find((item2) => item2.id === item.id)
            addUnit()
        }
        return {
            closeModal,
            onUpdateModelEstablishment,
            onUpdateBlockId,
            saveUser,
            runValidations,
            dropWareHouse,
            addWareHouse,
            addUnit,
            dropUnit,
            addParking,
            dropParking,
            onSelect,
            formattedUnitList,
            parkings,
            showModalAdd,
            wareHouses,
            showEmployeeRegister,
            establishmentType,
            firsName,
            lastName,
            profession,
            age,
            communityId,
            phone,
            hasReducedCapacity,
            isFab,
            reducedCapacityDetails,
            email,
            rut,
            position,
            commitePosition,
            isCommiteMember,
            parkingSpace,
            activeInput,
            warehouseSpace,
            searchTableData,
            showButtons,
            numBlock,
            hasRutError,
            hasEmailError,
            isFieldsFilled,
            establishments,
            floor,
            address,
            showModalEdit,
            showAlertModal,
            hasPhoneError,
            showAlert,
            message,
            loading,
            selectedUnit,
            unitSelector,
            units,
            showAlertMessage,
            alertType,
            unitsList,
            unitType,
            blockList,
            blockId
        };
    },
    components: { Modal, TextField, Alert, Selector, inputChipAuxVue, SearchSelector },
    watch: {
        'rut': {
            handler: function (newvalue) {
                if (!validateRut(newvalue)) {
                    this.hasRutError = true
                }
                else {
                    this.hasRutError = false
                }
            }
        },
        'email': {
            handler: function (newvalue) {
                if (!validateEmailStructure(newvalue)) {
                    this.hasEmailError = true
                }
                else {
                    this.hasEmailError = false
                }
            }
        },
        'phone': {
            handler: function (newvalue) {
                if (!verifyPhoneNumberFormat(newvalue)) {
                    this.hasPhoneError = true
                }
                else {
                    this.hasPhoneError = false
                }
            }
        },
    }
});
